import "./App.css";
import Header from "./components/Header.js";

import Stats from "./components/Stats.js";
import AboutPreview from "./components/AboutPreview.js";
import ServicesPreview from "./components/ServicesPreview.js";
import Partners from "./components/Partners.js";
import HowItWorks from "./components/HowItWorks.js";
import WhyUs from "./components/WhyUs.js";
import Sustainability from "./components/Sustainability.js";
import Testimonials from "./components/Testimonials.js";
import FAQPreview from "./components/FAQPreview.js";
import ContactCTA from "./components/ContactCTA.js";
import Footer from "./components/Footer.js";
import HeroSlider from "./components/HeroSlider.js";
import ProcessSection from "./components/ProcessSection.js";
import SocialMediaSection from "./components/SocialMediaSection.js";
import WhatsAppButton from "./components/WhatsAppButton.js";
import WhyUsSection from "./components/WhyUsSection.js";
import ProcessSection2 from "./components/ProcessSection2.js";

import About from "./pages/About";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home.js";

function App() {
  return (
    <div className="App">
      <Header className="" />

     

      <Routes>
        {/* الصفحة الرئيسية */}
        <Route path="/" element={<Home />} />

        {/* صفحة من نحن */}
        <Route path="/about" element={<About />} />

        {/* اختبار مؤقت */}
        <Route
          path="/hello"
          element={<h1 style={{ color: "white" }}>Hello World</h1>}
        />
      </Routes>

      {/* عناصر مشتركة بين جميع الصفحات */}
      <WhatsAppButton />
      <Footer />
    
    </div>
  );
}

export default App;
